/* unplugin-vue-components disabled */import { render } from "./index.vue?vue&type=template&id=37fa5daa"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=37fa5daa&lang=less"

import exportComponent from "/Users/wuxieshuan/Desktop/上海印高/WeCom_FE/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/copyright/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "37fa5daa"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('37fa5daa', __exports__)) {
    console.log('reload')
    api.reload('37fa5daa', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=37fa5daa", () => {
    console.log('re-render')
    api.rerender('37fa5daa', render)
  })

}


export default __exports__